import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import * as yup from "yup";
import { Button, Stack, TextField, Typography } from "@mui/material";
import { FieldControl, } from "@pangeacyber/react-mui-shared";
import { formatPhoneNumber, validatePhoneNumber } from "../../utils";
import { useCreateShareContext } from "../../hooks/context";
var UnControlledGetPhoneLinkField = function (_a) {
    var _b = _a.onValueChange, onValueChange = _b === void 0 ? function () { } : _b;
    var _c = useCreateShareContext(), loading = _c.loading, setSent = _c.setSent;
    var _d = useState(""), newValue = _d[0], setNewValue = _d[1];
    var _e = useState(undefined), newValueError = _e[0], setNewValueError = _e[1];
    var validate = function () {
        yup
            .string()
            .test("validate-phone", "Must be a valid phone number", validatePhoneNumber)
            .isValid(newValue)
            .then(function (isValid) {
            if (!isValid)
                setNewValueError("Must be a valid phone number");
            else
                setNewValueError(undefined);
        });
    };
    var handleSubmitValue = function () {
        if (!newValue || !!newValueError)
            return;
        var phoneValue_ = formatPhoneNumber(newValue);
        onValueChange(phoneValue_);
    };
    useEffect(function () {
        if (newValue === "") {
            setNewValueError(undefined);
            return;
        }
        if (!loading) {
            setSent(false);
            validate();
        }
    }, [newValue]);
    return (_jsxs(Stack, { gap: 1, width: "100%", children: [_jsx(Typography, { variant: "caption", color: "textSecondary", mt: 1, children: "Enter a phone number to protect the link with a one-time authentication code" }), _jsxs(Stack, { width: "100%", direction: "row", spacing: 1, alignItems: "flex-start", children: [_jsx(TextField, { value: newValue, name: "recipient_phone", label: "Phone number", onChange: function (e) {
                            var value = e.target.value;
                            setNewValue(value);
                            e.stopPropagation();
                        }, error: !!newValueError, helperText: newValueError, onKeyDown: function (event) { return event.stopPropagation(); }, autoComplete: "off", fullWidth: true, onBlur: validate, onKeyUp: function (event) {
                            if (event.key === "Enter") {
                                handleSubmitValue();
                                event.preventDefault();
                            }
                        }, size: "small", disabled: loading, InputProps: {
                            startAdornment: (_jsx(Typography, { color: "textSecondary", sx: { paddingRight: 1 }, children: "+1" })),
                        } }), _jsx(Button, { variant: "outlined", onClick: handleSubmitValue, disabled: !newValue || !!newValueError || loading, sx: {
                            minWidth: "100px",
                            textWrap: "nowrap",
                        }, children: loading ? "Saving..." : "Get Link" })] })] }));
};
var GetPhoneLinkField = function (props) {
    return (_jsx(FieldControl, __assign({}, props, { children: _jsx(UnControlledGetPhoneLinkField, __assign({}, props)) })));
};
export default GetPhoneLinkField;
